import React from 'react';

/**
 * Floating contact buttons (WhatsApp + Discord) pinned to the bottom-right.
 * Lets customers reach support directly from any page.
 */
const WHATSAPP_NUMBER = '201004857321';
const DISCORD_INVITE  = 'https://discord.gg/9FEfY52h';

const FloatingContact: React.FC = () => (
  <div className="ot-fab-stack" aria-label="Contact support">
    <a
      className="ot-fab ot-fab-whatsapp"
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <span className="ot-fab-label">WhatsApp</span>
      <i className="fab fa-whatsapp"></i>
    </a>

    <a
      className="ot-fab ot-fab-discord"
      href={DISCORD_INVITE}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Join our Discord server"
    >
      <span className="ot-fab-label">Discord</span>
      <i className="fab fa-discord"></i>
    </a>
  </div>
);

export default FloatingContact;
